import { cx } from "../../cx";
import styles from "./flag-icon.module.css";

export interface FlagIconProps {
  /** ISO 3166-1 alpha-2 country code (any case). */
  code: string;
  className?: string;
  /** Eager-load the flag that is always on screen (a picker's selected chip).
   *  Rows inside a closed dropdown stay lazy. */
  eager?: boolean;
}

/**
 * Country flag as a self-hosted 4:3 SVG (`public/flags/<code>.svg`), not
 * emoji: Windows renders flag emoji as the bare two-letter code. Decorative,
 * because the country name always sits beside it, so `alt=""`.
 */
export function FlagIcon({ code, className, eager = false }: FlagIconProps) {
  return (
    <img
      data-tui=""
      data-slot="flag-icon"
      src={`/flags/${code.toLowerCase()}.svg`}
      alt=""
      aria-hidden
      width={20}
      height={15}
      loading={eager ? "eager" : "lazy"}
      decoding="async"
      className={cx(styles.flag, className)}
    />
  );
}
